import React from "react";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

export default function NumberFormatter(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator={false} // TODO: check how to change decimal to comma instead of dot THIS IS NOT AMERICA
      isNumericString
    />
  );
}

NumberFormatter.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
